import {NgModule} from "@angular/core";
import {Routes, RouterModule,PreloadAllModules } from "@angular/router";
import {LoginComponent} from "./login/login.component";
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
import {P401Component} from "./views/pages/401.component";
import {FullLayoutComponent, SimpleLayoutComponent} from "./containers";
import {RouteResolver} from "./route.resolver";
import {RedirectionComponent} from "./redirection/redirection.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {PrivacyPolicyComponent} from "./privacy-policy/privacy-policy.component";
import {SupplierEvaluationFormComponent} from "./supplier-evaluation-form/supplier-evaluation-form/supplier-evaluation-form.component";
import {SupplierEvaluationSuccessComponent} from "./supplier-evaluation-form/supplier-evaluation-success/supplier-evaluation-success.component";
import { WorkflowComponentComponent } from "./workflow-component/workflow-component.component";
import { WorkflowconfigComponent } from "./workflowconfig/workflowconfig.component";
import { RedirectComponent } from "./RedirectComponent";
import {SelectivePreloadStrategy} from './selective-preload.strategy';

export const routes: Routes = [
  {
    path: "",
    redirectTo: "pages/login",
    pathMatch: "full",
    data: {preload: true},
  },
  {
    path: "",
    component: FullLayoutComponent,
    data: {
      title: "Home",
    },
    children: [
     
      {
        path: "home",
        // loadChildren: "./home/home.module#HomeModule",
          component: RedirectComponent
      },
      {
        path: "workflow",
        component: WorkflowComponentComponent,
      },
      {
        path: "workflow-congiration",
        component: WorkflowconfigComponent,
      },
      {
        path: "401",
        component: P401Component,
        data: {
          title: "Page Not Accessible",
        },
      },
      {
        path: "configuration",
        loadChildren:
          "./configuration/configuration.module#ConfigurationModule",
      },


      {
        path: "competancy",
        loadChildren:
          "./competancy/competancy.module#CompetancyModule",
      },

     


      {
        path: "questionnaire",
        loadChildren:
          "./configuration/questionnaire/questionnaire.module#QuestionnaireModule",
      },
      {
        path: "backups",
        loadChildren: "./backup/backup.module#BackupModule",
      },
      {
        path: "survey-management",
        loadChildren:
          "./survey-management/survey-management.module#SurveyManagementModule",
      },
      {
        path: "dms",
        loadChildren: "./dms/dms.module#DmsModule",
      },
      {
        path: "create-new-entry",
        loadChildren:
          "./create-new-entry/create-new-entry.module#CreateNewEntryModule",
      },
      {
        path: "audit-management",
        loadChildren:
          "./audit-management/audit-management.module#AuditManagementModule",
      },
      {
        path: "meetings",
        loadChildren: "./meetings/meetings.module#MeetingsModule",
      },
      
      {
        path: "reports",
        loadChildren: "./reports/reports.module#ReportsModule",
      },
      {
        path: "training",
        loadChildren: "app/training/training.module#TrainingModule",
      },
      {
        path: "training-program",
        loadChildren: "./training-program/training-program.module#TrainingProgramModule",
      },
      {
        path: "my-reports",
        loadChildren: "./my-reports/my-reports.module#MyReportsModule",
      },
      {
        path: "my-action-items",
        loadChildren:
          "./my-action-items/my-action-items.module#MyActionItemsModule",
      },
      {
        path: "journey",
        loadChildren: "./journey/journey.module#JourneyModule",
      },
      {
        path: "management-of-change",
        loadChildren:
          "./management-of-change/management-of-change.module#ManagementOfChangeModule",
      },
      {
        path: "plan",
        loadChildren: "./plan/plan.module#PlanModule",
      },
      {
        path: "approval-management",
        loadChildren:
          "./approval-management/approval-management.module#ApprovalManagementModule",
      },
      {
        path: "recognition",
        loadChildren: "./recognition/recognition.module#RecognitionModule",
      },
      {
        path: "performance-evaluation",
        loadChildren:
          "./performance-evaluation/performance-evaluation.module#PerformanceEvaluationModule",
      },
      /*      {
        path: 'form-builder-reports',
        loadChildren: './form-builder-page/form-builder-page.module#FormBuilderPageModule'
      },*/
     
      {
        path: "ncr-management",
        loadChildren:
          "./non-conformance-report/mazoon-template/mazoon-template.module#MazoonTemplateModule",
      },
      {
        path: "noe-management",
        loadChildren:
          "./notice-of-explanation/mazoon-template/mazoon-template.module#MazoonTemplateModule",
      },
      {
        path: "acc-management",
        loadChildren:
          "./accident-report/default-template/default-template.module#DefaultTemplateModule",
      },
      {
        path: "mvr-management",
        loadChildren:
          "./management-visit-report/mazoon-template/mazoon-template.module#MazoonTemplateModule",
      },
      {
        path: "mhr-management",
        loadChildren:
          "./monthly-hse-report/mazoon-template/mazoon-template.module#MazoonTemplateModule",
      },
      {
        path: "supplier-evaluation",
        loadChildren:
          "./supplier-evaluation/supplier-evaluation.module#SupplierEvaluationModule",
      },
     
      {
        path: "equipment-management",
        loadChildren:
          "./equipment-management/equipment-management.module#EquipmentManagementModule",
      },
      {
        path: "imi-default",
        loadChildren:
          "./incident-management-icam/default-template/default-template.module#DefaultTemplateModule",
      },
     
      {
        path: "imi-newtemplate-default",
        loadChildren:
          "./incident-management-template-icam/default-template/default-new-template.module#DefaultNewTemplateModule",
      },
      {
        path: "imi-arabian-default",
        loadChildren:
          "./incident-management-arabian-icam/default-template/default-arabian-template.module#DefaultArabianTemplateModule",
      },
      {
        path: "ncr-batty-hamood",
        loadChildren:
          "./non-conformance-report/batty-hamood/batty-hamood.module#BattyHamoodModule",
      },
      {
        path: "ncr-nesr",
        loadChildren:
          "./non-conformance-report/nesr-template/nesr-template.module#NesrTemplateModule",
      },
      
      {
        path: "audit-general",
        loadChildren:
          "./audit-report/audit-report-general/audit-report-general.module#AuditReportGeneralModule",
      },
      {
        path: "nesr-rir",
        loadChildren:
          "./rir/nesr-template/nesr-template.module#NesrTemplateModule",
      },
      {
        path: "iloops-rir",
        loadChildren:
          "./rir/nesr-template/nesr-template.module#NesrTemplateModule",
      },
      {
        path: "nesr-mvr",
        loadChildren:
          "./management-visit-report/nesr-template/nesr-template.module#NesrTemplateModule",
      },
      {
        path: "mhr-nesr",
        loadChildren:
          "./monthly-hse-report/nesr-template/nesr-template.module#NesrTemplateModule",
      },
      {
        path: "mhr-ofsat",
        loadChildren:
          "./monthly-hse-report/ofsat-template/ofsat-template.module#OfsatTemplateModule",
      },
     
      {
        path: "incoming-material-inspection",
        loadChildren:
          "./incoming-material-inspection/incoming-material-inspection.module#IncomingMaterialInspectionModule",
      },
    ],
  },
 
  {
    path: "pages",
    component: SimpleLayoutComponent,
    data: {
      title: "Account",
    },
    children: [
      {
        path: "login",
        component: LoginComponent,
      },
      {
        path: "redirection/:id",
        component: RedirectionComponent,
      },
      {
        path: "forgot-password",
        component: ForgotPasswordComponent,
      },
      {
        path: "reset-password/:id",
        component: ResetPasswordComponent,
      },
    ],
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent,
    data: {preload: true, title: "Privacy Policy"},
  },
  {
    path: "supplier-evaluation-form",
    component: SupplierEvaluationFormComponent,
    data: {preload: true, title: "Supplier Evaluation"},
  },
  {
    path: "supplier-evaluation-success",
    component: SupplierEvaluationSuccessComponent,
    data: {preload: true, title: "Supplier Evaluation Success"},
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: false, preloadingStrategy: SelectivePreloadStrategy})],
  exports: [RouterModule],
})
export class AppRoutingModule {
}

//{onSameUrlNavigation:'reload'}



// WEBPACK FOOTER //
// /app/src/app/app.routing.ts